import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#0066FF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#CC092F',
        info: '#2196F3',
        success: '#11C25C',
        warning: '#FFBC00',
        footer: '#011a2e',
        lgrey: '#d9d9d9',
        sucess2:'#0066FF',
      },
      dark: {
        footer: '#011a2e'
      }
    },
  },
    lang: {
      locales: { pt },
      current: 'pt',
    },
  icons: {
    iconfont: 'fa',
  },
});
